import api from "../api";
import { MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD } from "../constants/files";

export const isActiveAttachment = (attachment: api.AttachmentDetails) => !attachment.assignment_is_archived;

export const isValidFile = (file: File) => file.size <= MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD;
